import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const NEXT = { member_monthly: "/discover", vip_monthly: "/cams", tokens_100: "/cams", tokens_1000: "/cams" };

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");
  const [key, setKey] = useState("");
  useEffect(() => {
    const sid = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setKey(data.lookup_key);
        if (data.payment_status === "paid") { setState("paid"); refresh(); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); return; }
      } catch (e) { /* keep polling */ }
      if (++tries < 15) timer = setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, refresh]);
  return (
    <main className="mx-auto max-w-lg px-5 py-24 text-center" data-testid="payment-success-page">
      {state === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-red-500" /><p className="mt-6 text-zinc-400">Confirming your payment…</p></>}
      {state === "paid" && (
        <><CheckCircle2 className="mx-auto h-12 w-12 text-red-500" /><h1 data-testid="payment-status-paid" className="font-display mt-6 text-5xl">Payment confirmed</h1>
          <Link to={NEXT[key] || "/wallet"} data-testid="payment-continue-btn" className="btn-red mt-10 inline-block rounded-full px-10 py-3 font-semibold">Continue</Link></>
      )}
      {(state === "failed" || state === "timeout") && (
        <><XCircle className="mx-auto h-12 w-12 text-zinc-500" /><h1 data-testid="payment-status-failed" className="font-display mt-6 text-4xl">{state === "failed" ? "Payment not completed" : "Still processing — check back shortly"}</h1>
          <Link to="/wallet" className="mt-8 inline-block text-red-500">Go to wallet</Link></>
      )}
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main className="mx-auto max-w-lg px-5 py-24 text-center" data-testid="payment-cancel-page">
      <h1 className="font-display text-5xl">Checkout cancelled</h1>
      <p className="mt-4 text-zinc-400">No charge was made.</p>
      <Link to="/membership" className="btn-red mt-10 inline-block rounded-full px-10 py-3 font-semibold">Back to plans</Link>
    </main>
  );
}
